import { render, staticRenderFns } from "./TjingRadioButtons.vue?vue&type=template&id=03959bba&scoped=true"
import script from "./TjingRadioButtons.vue?vue&type=script&lang=js"
export * from "./TjingRadioButtons.vue?vue&type=script&lang=js"
import style0 from "./TjingRadioButtons.vue?vue&type=style&index=0&id=03959bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03959bba",
  null
  
)

export default component.exports